<template>
  <SettingsPageLayout>
    <DetailForm
      title="Stripe"
      description="The Stripe integration allows us to connect all of your billing information directly in Humaniz from Stripe where it is stored."
      action="Save"
      @handleAction="updateTeam"
      hidecancel="true"
      v-if="loaded"
    >
      <TextInput
        label="Stripe Customer Id"
        placeholder="cus_N6NLGguLBSmSVj"
        :modelValue="team.stripeCustomerId"
        @update:modelValue="value => (team.stripeCustomerId = value)"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      team: {
        id: '',
        stripeCustomerId: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/1`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.team.id = data.id;
          self.team.stripeCustomerId = data.record.stripe_customer_id;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          stripe_customer_id: self.team.stripeCustomerId,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Stripe integration updated',
              alertDescription:
                'Your Stripe integration was successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Stripe integration update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
